import { render, staticRenderFns } from "./AppRadio.vue?vue&type=template&id=7b5442f4&scoped=true"
import script from "./AppRadio.vue?vue&type=script&lang=js"
export * from "./AppRadio.vue?vue&type=script&lang=js"
import style0 from "./AppRadio.vue?vue&type=style&index=0&id=7b5442f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5442f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
